import {
  IonButton,
  IonItem,
  IonList,
  IonRadio,
  IonRadioGroup,
  ModalController,
} from '@ionic/angular/standalone';

import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormHelpers } from 'src/app/util/form-helpers';

import { CountryEnv } from './../../models/CountryEnv';
import { HttpHelperService } from './../../services/http-helper/http-helper.service';
import { PageHelperService } from './../../services/page-helper/page-helper.service';
import { StorageManagerService } from './../../services/storage-manager/storage-manager.service';

@Component({
  selector: 'app-choose-environment',
  templateUrl: './choose-environment.component.html',
  styleUrls: ['./choose-environment.component.scss'],
  imports: [IonButton, IonItem, IonList, IonRadio, IonRadioGroup, ReactiveFormsModule],
})
export class ChooseEnvironmentComponent {
  private httpHelper = inject(HttpHelperService);
  private pageHelper = inject(PageHelperService);
  private modalCtrl = inject(ModalController);
  formBuilder = inject(FormBuilder);

  public environments: Array<any>;
  public currentEnvironment: CountryEnv;
  public originalEnvironment: CountryEnv;
  private envStorageKey = 'devEnvironmentObj';
  private envStorageManager: StorageManagerService = inject(StorageManagerService);
  public envForm: FormGroup;
  public formHelper: FormHelpers = new FormHelpers();

  constructor() {
    this.environments = this.httpHelper.OTHER_ENDPOINTS;
    this.currentEnvironment = this.httpHelper.BASE_ENV;
    this.originalEnvironment = this.httpHelper.BASE_ENV;
    this.envStorageManager.storageIdentifier = this.envStorageKey;

    this.envForm = this.formBuilder.group({
      env: [this.currentEnvironment.name, Validators.required],
    });
  }

  public updateEnvironment(env: CountryEnv) {
    this.envStorageManager.localStorageSetItem(JSON.stringify(env));
    this.currentEnvironment = env;
  }

  public dismiss() {
    if (this.originalEnvironment.name !== this.currentEnvironment.name) {
      this.pageHelper.showLoader().then(() => {
        window.location.reload();
      });
    } else {
      this.modalCtrl.dismiss();
    }
  }
}
